import { useState } from 'react';

import { PlaceSelectSheet } from './PlaceSelectSheet';
import { PlaceTakenForm } from './PlaceTakenForm';
import { PlaceTakenSelection } from './types';

type PlaceTakenFlowProps = {
	opened: boolean;
	close: () => void;
};

type Step = 'select' | 'form';

export const PlaceTakenFlow = ({ opened, close }: PlaceTakenFlowProps) => {
	const [step, setStep] = useState<Step>('select');
	const [selection, setSelection] = useState<PlaceTakenSelection | null>(null);

	const handleClose = () => {
		close();
		setStep('select');
		setSelection(null);
	};

	return (
		<>
			<PlaceSelectSheet
				opened={opened && step === 'select'}
				onClose={handleClose}
				onSelect={(value) => {
					setSelection(value);
					setStep('form');
				}}
			/>

			{selection && (
				<PlaceTakenForm
					opened={opened && step === 'form'}
					selection={selection}
					onBack={() => setStep('select')}
					onClose={handleClose}
				/>
			)}
		</>
	);
};
